module.exports = __webpack_public_path__ + "static/media/realtors-icon-10.22dc6fc3.svg";